import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Container } from "./styles";
import Logo from "../../assets/images/svg-Logo.svg";
import Overview from "../../assets/images/svg-Overview.svg";
import ChecklistDo from "../../assets/images/svg-CheckDo.svg";
import ChecklistAn from "../../assets/images/svg-CheckAn.svg";
import ChecklistCo from "../../assets/images/svg-CheckCo.svg";
import ProcessManager from "../../assets/images/svg-ProcessManager.svg";
import User from "../../assets/images/svg-User.svg";
import Analytics from "../../assets/images/svg-Analytics.svg";
import Consulta from "../../assets/images/svg-Consulta.svg";
import PowerOff from "../../assets/images/svg-PowerOff.svg";

import AuthContext from "../../contexts/sessionContext";

const items = [
	[
		{
			path: "/dashboard",
			img: Overview,
			text: "Visão Geral",
		},
		{
			path: "/checklist-an",
			img: ChecklistAn,
			text: "Checklist Analistas",
		},
		{
			path: "/checklist-do",
			img: ChecklistDo,
			text: "Checklist Documentos",
		},
		{
			path: "/checklist-corretor",
			img: ChecklistCo,
			text: "Checklist Corretor",
		},
		{
			path: "/gerenciamento-de-processos",
			img: ProcessManager,
			text: "Gerenciamento de Processos",
		},
		{
			path: "/gerenciamento-de-cadastros",
			img: User,
			text: "Gerenciamento de Cadastros",
		},
		{
			path: "/analise",
			img: Analytics,
			text: "Análises",
		},
	],
	[
		{
			path: "/dashboard",
			img: Overview,
			text: "Visão Geral",
		},
		{
			path: "/consulta",
			img: Consulta,
			text: "Consulta",
		},
		{
			path: "/gerenciamento-de-processos",
			img: ProcessManager,
			text: "Gerenciamento de processos",
		},
	],
	[
		{
			path: "/dashboard",
			img: Overview,
			text: "Visão Geral",
		},
		{
			path: "/consulta",
			img: Consulta,
			text: "Consulta",
		},
		{
			path: "/gerenciamento-de-processos",
			img: ProcessManager,
			text: "Gerenciamento de processos",
		},
	],
];

function Sidebar() {
	const location = useLocation();
	const { user, signOut } = useContext(AuthContext);
	const [current_items, setCurrentItems] = useState([]);

	useEffect(() => {
		// @ts-ignore
		setCurrentItems(items[user.role]);
	}, [user, items]);

	return (
		<Container>
			<div className='image-wrapper'>
				<img src={Logo} alt='realizar_logo' />
			</div>

			<ul className='button-wrapper'>
				{current_items.map((item: any, index: number) => (
					<Link to={item.path} className='item' key={index}>
						<li
							className={`${
								location.pathname === item.path
									? "active"
									: null
							}`}>
							<img src={item.img} alt='button_img' />
							{item.text}
						</li>
					</Link>
				))}

				<Link to='' className='item' id='logout' onClick={signOut}>
					<li>
						<img src={PowerOff} alt='logoff_img' />
						Sair
					</li>
				</Link>
			</ul>
		</Container>
	);
}

export default Sidebar;
